// extracted by mini-css-extract-plugin
module.exports = {"progress_holder":"Progress_progress_holder__3SCD7","progress_bar":"Progress_progress_bar__2vemW"};